export const MAP_W = 1535
export const MAP_H = 1244

export const stitchData = {
  "1": { x: 32, y: 32, scale: 105 }, "2": { x: 374, y: 234, scale: 76 }, "3": { x: 506, y: -9, scale: 157 },
  "4": { x: 1139, y: -21, scale: 77 }, "5": { x: 1117, y: 181, scale: 63 }, "6": { x: 1023, y: 274, scale: 48 },
  "7": { x: 830, y: 288, scale: 54 }, "8": { x: 908, y: 336, scale: 25 }, "9": { x: 727, y: 351, scale: 44 },
  "10": { x: 589, y: 379, scale: 52 }, "11": { x: 611, y: 371, scale: 26 }, "13": { x: 238, y: 313, scale: 73 },
  "14": { x: -12, y: 323, scale: 91 }, "15": { x: 355, y: 476, scale: 70 }, "16": { x: 537, y: 598, scale: 41 },
  "17": { x: 635, y: 572, scale: 55 }, "18": { x: 718, y: 476, scale: 49 }, "19": { x: 863, y: 435, scale: 58 },
  "20": { x: 905, y: 537, scale: 41 }, "21": { x: 847, y: 549, scale: 38 }, "22": { x: 902, y: 661, scale: 43 },
  "23": { x: 750, y: 706, scale: 45 }, "24": { x: 614, y: 672, scale: 45 }, "25": { x: 453, y: 694, scale: 45 },
  "26": { x: 257, y: 642, scale: 61 }, "27": { x: 449, y: 798, scale: 58 }, "28": { x: 557, y: 846, scale: 67 },
  "29": { x: 813, y: 779, scale: 43 }, "32": { x: 900, y: 895, scale: 44 }, "33": { x: 498, y: 1014, scale: 28 },
}

export const provinceDims = {
  "1": { w: 517, h: 383 }, "2": { w: 381, h: 375 }, "3": { w: 786, h: 481 }, "4": { w: 394, h: 321 },
  "5": { w: 315, h: 207 }, "6": { w: 257, h: 183 }, "7": { w: 258, h: 241 }, "8": { w: 112, h: 86 },
  "9": { w: 215, h: 223 }, "10": { w: 259, h: 285 }, "11": { w: 132, h: 163 },
  "13": { w: 376, h: 273 }, "14": { w: 452, h: 377 }, "15": { w: 343, h: 316 }, "16": { w: 206, h: 173 },
  "17": { w: 291, h: 202 }, "18": { w: 232, h: 213 }, "19": { w: 298, h: 167 }, "20": { w: 212, h: 204 },
  "21": { w: 191, h: 232 }, "22": { w: 201, h: 201 }, "23": { w: 237, h: 233 }, "24": { w: 232, h: 240 },
  "25": { w: 232, h: 183 }, "26": { w: 310, h: 308 }, "27": { w: 282, h: 211 }, "28": { w: 347, h: 219 },
  "29": { w: 232, h: 212 }, "32": { w: 230, h: 315 }, "33": { w: 149, h: 116 },
}

export const provinceGeo = {
  "1": { name: "新疆", bounds: [73.5, 96.4, 34.3, 49.2], capital: { name: "乌鲁木齐", lng: 87.62, lat: 43.79 } },
  "2": { name: "甘肃", bounds: [92.3, 108.7, 32.6, 42.8], capital: { name: "兰州", lng: 103.83, lat: 36.06 } },
  "3": { name: "内蒙古", bounds: [97.2, 126.1, 37.4, 53.4], capital: { name: "呼和浩特", lng: 111.75, lat: 40.84 } },
  "4": { name: "黑龙江", bounds: [121.2, 135.1, 43.4, 53.6], capital: { name: "哈尔滨", lng: 126.63, lat: 45.75 } },
  "5": { name: "吉林", bounds: [121.6, 131.3, 40.9, 46.3], capital: { name: "长春", lng: 125.32, lat: 43.88 } },
  "6": { name: "辽宁", bounds: [118.8, 125.8, 38.7, 43.5], capital: { name: "沈阳", lng: 123.43, lat: 41.8 } },
  "7": { name: "河北天津", bounds: [113.1, 119.9, 36.0, 42.6], capital: { name: "石家庄", lng: 114.51, lat: 38.04 } },
  "8": { name: "北京", bounds: [115.4, 117.5, 39.4, 41.1], capital: { name: "北京", lng: 116.41, lat: 39.9 } },
  "9": { name: "山西", bounds: [110.2, 114.6, 34.6, 40.7], capital: { name: "太原", lng: 112.55, lat: 37.87 } },
  "10": { name: "陕西", bounds: [105.5, 111.2, 31.7, 39.6], capital: { name: "西安", lng: 108.95, lat: 34.27 } },
  "11": { name: "宁夏", bounds: [104.3, 107.7, 35.2, 39.4], capital: { name: "银川", lng: 106.27, lat: 38.47 } },
  "13": { name: "青海", bounds: [89.4, 103.1, 31.6, 39.2], capital: { name: "西宁", lng: 101.78, lat: 36.62 } },
  "14": { name: "西藏", bounds: [78.4, 99.1, 26.9, 36.5], capital: { name: "拉萨", lng: 91.13, lat: 29.65 } },
  "15": { name: "四川", bounds: [97.3, 108.6, 26.0, 34.3], capital: { name: "成都", lng: 104.07, lat: 30.67 } },
  "16": { name: "重庆", bounds: [105.3, 110.2, 28.2, 32.2], capital: { name: "重庆", lng: 106.55, lat: 29.56 } },
  "17": { name: "湖北", bounds: [108.4, 116.1, 29.0, 33.3], capital: { name: "武汉", lng: 114.31, lat: 30.52 } },
  "18": { name: "河南", bounds: [110.4, 116.7, 31.4, 36.4], capital: { name: "郑州", lng: 113.65, lat: 34.76 } },
  "19": { name: "山东", bounds: [114.8, 122.7, 34.4, 38.4], capital: { name: "济南", lng: 117.0, lat: 36.67 } },
  "20": { name: "江苏上海", bounds: [116.4, 122.0, 30.7, 35.1], capital: { name: "南京", lng: 118.78, lat: 32.06 } },
  "21": { name: "安徽", bounds: [114.9, 119.7, 29.4, 34.7], capital: { name: "合肥", lng: 117.28, lat: 31.86 } },
  "22": { name: "浙江", bounds: [118.0, 122.8, 27.1, 31.2], capital: { name: "杭州", lng: 120.15, lat: 30.27 } },
  "23": { name: "江西", bounds: [113.6, 118.5, 24.5, 30.1], capital: { name: "南昌", lng: 115.89, lat: 28.68 } },
  "24": { name: "湖南", bounds: [108.8, 114.3, 24.6, 30.1], capital: { name: "长沙", lng: 112.94, lat: 28.23 } },
  "25": { name: "贵州", bounds: [103.6, 109.6, 24.6, 29.2], capital: { name: "贵阳", lng: 106.71, lat: 26.57 } },
  "26": { name: "云南", bounds: [97.5, 106.2, 21.1, 29.3], capital: { name: "昆明", lng: 102.83, lat: 25.05 } },
  "27": { name: "广西", bounds: [104.3, 112.1, 20.5, 26.4], capital: { name: "南宁", lng: 108.37, lat: 22.81 } },
  "28": { name: "广东", bounds: [109.7, 117.3, 20.2, 25.5], capital: { name: "广州", lng: 113.26, lat: 23.13 } },
  "29": { name: "福建", bounds: [115.8, 120.7, 23.5, 28.3], capital: { name: "福州", lng: 119.3, lat: 26.08 } },
  "32": { name: "台湾", bounds: [120.0, 122.0, 21.9, 25.3], capital: { name: "台北", lng: 121.56, lat: 25.04 } },
  "33": { name: "海南", bounds: [108.6, 111.1, 18.2, 20.2], capital: { name: "海口", lng: 110.35, lat: 20.02 } },
}

export const SAVED_CAL = [
  { name: "乌鲁木齐", lng: 87.62, lat: 43.79, px: 24.49, py: 15.05 },
  { name: "兰州", lng: 103.83, lat: 36.06, px: 39.33, py: 38.05 },
  { name: "呼和浩特", lng: 111.75, lat: 40.84, px: 55.15, py: 28.71 },
  { name: "哈尔滨", lng: 126.63, lat: 45.75, px: 84, py: 17.72 },
  { name: "长春", lng: 125.32, lat: 43.88, px: 80.64, py: 22.01 },
  { name: "沈阳", lng: 123.43, lat: 41.8, px: 75.97, py: 28.15 },
  { name: "石家庄", lng: 114.51, lat: 38.04, px: 58.94, py: 35.78 },
  { name: "北京", lng: 116.41, lat: 39.9, px: 63.17, py: 31.33 },
  { name: "太原", lng: 112.55, lat: 37.87, px: 54.21, py: 37.48 },
  { name: "西安", lng: 108.95, lat: 34.27, px: 45.46, py: 45.48 },
  { name: "银川", lng: 106.27, lat: 38.47, px: 44.41, py: 34.32 },
  { name: "西宁", lng: 101.78, lat: 36.62, px: 35.06, py: 36.04 },
  { name: "拉萨", lng: 91.13, lat: 29.65, px: 13.68, py: 46.1 },
  { name: "成都", lng: 104.07, lat: 30.67, px: 33.63, py: 52.49 },
  { name: "重庆", lng: 106.55, lat: 29.56, px: 38.8, py: 56.07 },
  { name: "武汉", lng: 114.31, lat: 30.52, px: 53.19, py: 56.28 },
  { name: "郑州", lng: 113.65, lat: 34.76, px: 55.42, py: 45.07 },
  { name: "济南", lng: 117, lat: 36.67, px: 61.48, py: 40.62 },
  { name: "南京", lng: 118.78, lat: 32.06, px: 64.02, py: 53.11 },
  { name: "合肥", lng: 117.28, lat: 31.86, px: 61.32, py: 54.07 },
  { name: "杭州", lng: 120.15, lat: 30.27, px: 65.14, py: 60.33 },
  { name: "南昌", lng: 115.89, lat: 28.68, px: 55.71, py: 61.26 },
  { name: "长沙", lng: 112.94, lat: 28.23, px: 48.89, py: 62.26 },
  { name: "贵阳", lng: 106.71, lat: 26.57, px: 36.7, py: 63.94 },
  { name: "昆明", lng: 102.83, lat: 25.05, px: 27.9, py: 65.74 },
  { name: "南宁", lng: 108.37, lat: 22.81, px: 37.07, py: 74.26 },
  { name: "广州", lng: 113.26, lat: 23.13, px: 46.71, py: 75.23 },
  { name: "福州", lng: 119.3, lat: 26.08, px: 60.93, py: 70.55 },
  { name: "台北", lng: 121.56, lat: 25.04, px: 67.77, py: 74.81 },
  { name: "海口", lng: 110.35, lat: 20.02, px: 37.51, py: 84.18 },
]

export const PULSE_COLORS = {
  blue: "rgba(64,158,255,1)",
  green: "rgba(76,175,80,1)",
  gray: "rgba(158,158,158,1)",
  yellow: "rgba(255,193,7,1)",
}

export const IMG_BASE = "/new-map/images"
